import {Tag} from '@/components/atoms'
import {PageHeader, TabsComponent, OverViewSubHeader} from '@/components/molecules'
import {PageContainer} from '@/components/organisms'
import {StoreDetailsBlock} from '@/containers'
import {TAG_COLOR} from '@/utils/constants/colors'

export const StoreDetails = () => {
  const tabList = [
    {
      id: 'Profile',
      tabLabel: 'Profile',
      tabComponent: '',
    },
    {
      id: 'Relational Data',
      tabLabel: 'Relational Data',
      tabComponent: '',
    },
    {
      id: 'Sales Details',
      tabLabel: 'Sales Details',
      tabComponent: '',
    },
    {
      id: 'Payment Details',
      tabLabel: 'Payment Details',
      tabComponent: '',
    },
    {
      id: 'Sales Target',
      tabLabel: 'Sales Targets',
      tabComponent: '',
    },
    {
      id: 'Activities',
      tabLabel: 'Activities',
      tabComponent: '',
    },
  ]
  return (
    <>
      <div className="flex items-center ">
        <PageHeader title={'Store Overview'} />
        <div className="ml-6">
          <Tag color={TAG_COLOR.CYAN_500} text="Active" />
        </div>
      </div>

      <OverViewSubHeader
        id={'store_overview_sub_header'}
        items={[
          {label: 'Store ID', value: '746456'},
          {label: 'Store Type', value: 'AFH'},
          {label: 'Label', value: 'value'},
        ]}
      />
      <TabsComponent isBorderVisible={true} className="mt-8 w-full pb-2" tabList={tabList} defaultTabIndex={0} />

      <PageContainer data-testid="store-list-page-content">
        <StoreDetailsBlock />
      </PageContainer>
    </>
  )
}

export default StoreDetails
